import React from 'react';
import PropTypes from 'prop-types';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import ReactFlow, { ReactFlowProvider } from 'reactflow';
import 'reactflow/dist/style.css';

import FlowDiagram from '../graphs/FlowDiagram';
import FlowDiagramAgac from '../graphs/FlowDiagramAgac';
import ZoomableSunBurst from '../graphs/ZoomableSunBurst';
import IndentedTree from '../graphs/IndentedTree';
import CirclePacking from '../graphs/CirclePacking';

/**
 * Görselleştirme bileşenlerini içeren panel
 */
function VisualizationPanel({ isEmriData = [], theme, activeVisualization = 'indentedTree' }) {
    // Veri yoksa gösterilecek içerik
    if (!isEmriData || isEmriData.length === 0) {
        return (
            <MDBox
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    color: theme?.colors?.text?.secondary,
                }}
            >
                <MDTypography
                    variant="body2"
                    sx={{
                        color: theme?.colors?.text?.secondary || '#64748B',
                        fontFamily: theme?.fontFamily,
                    }}
                >
                    Görselleştirme için henüz veri bulunmamaktadır.
                </MDTypography>
            </MDBox>
        );
    }

    // Seçilen görselleştirmeyi render et
    const renderVisualization = () => {
        switch (activeVisualization) {
            case 'flow':
                return (
                    <MDBox height="100%" width="100%" display="flex" flexDirection="column">
                        <MDBox flex={1} minHeight="600px" mt={1}>
                            <FlowDiagram data={isEmriData} height="100%" theme={theme} />
                        </MDBox>
                    </MDBox>
                );
            case 'tree':
                return (
                    <MDBox height="100%" width="100%" display="flex" flexDirection="column">
                        <MDBox flex={1} minHeight="600px" mt={1}>
                            <ReactFlowProvider>
                                <FlowDiagramAgac data={isEmriData} height="100%" theme={theme} />
                            </ReactFlowProvider>
                        </MDBox>
                    </MDBox>
                );
            case 'sunburst':
                return (
                    <MDBox height="100%" width="100%" display="flex" flexDirection="column">
                        <MDBox flex={1} minHeight="600px" mt={1}>
                            <ZoomableSunBurst data={isEmriData} height="100%" theme={theme} />
                        </MDBox>
                    </MDBox>
                );
            case 'indentedTree':
                return (
                    <MDBox height="100%" width="100%" display="flex" flexDirection="column">
                        <MDBox flex={1} minHeight="600px" mt={1}>
                            <IndentedTree data={isEmriData} height="100%" theme={theme} />
                        </MDBox>
                    </MDBox>
                );
            case 'circlePacking':
                return (
                    <MDBox height="100%" width="100%" display="flex" flexDirection="column">
                        <MDBox flex={1} minHeight="600px" mt={1}>
                            <CirclePacking data={isEmriData} height="100%" theme={theme} />
                        </MDBox>
                    </MDBox>
                );
            default:
                return null;
        }
    };

    return <MDBox height="100%">{renderVisualization()}</MDBox>;
}

VisualizationPanel.propTypes = {
    isEmriData: PropTypes.array,
    theme: PropTypes.object,
    activeVisualization: PropTypes.string,
};

export default VisualizationPanel;
